import React from 'react'
import TitleContentSection from '../titlecontentsection/TitleContentSection'
import MessageBox from '../messagebox/MessageBox'
import { Carousel } from 'react-responsive-carousel'
import Pic1 from './SALA-CLINICA-1.png'
import Pic2 from './SALA-CLINICA-2.png'
import Pic3 from './SALA-CLINICA-3.png'
import './Clinica.css'
import BaseComponent from '../basecomponent/BaseComponent'


const equipoContent = [
    {
        title: "Equipo médico",
        items: [ "Médico estomatólogo", "Ortodoncista", "Cirujano/Implantólogo" ]
    }, {
        title: "Equipo auxiliar",
        items: [ "Higienistas", "Recepcionista", "Administrativo" ]
    }
]

const instalacionesContent = [
    {
        items: [ "3 salas clínicas", "Radiografía digital", "Ortopantomografía digital" ]
    }, {
        items: [ "Sala de esterilización", "Instalaciones adaptadas para discapacitados" ]
    }
]


const SectionPart = (props) => (
    <div className="Clinica-Section-Part">
        { props.content.title !== undefined && <h4 className="Clinica-Section-Part-List-Title">{props.content.title}</h4> }
        <ul className="Clinica-Section-Part-List">
            { props.content.items.map((e,i) => <li className="Clinica-Section-Part-List-Item" key={i}>{e}</li> ) }
        </ul>
    </div>
)

const galleryPictures = [
    {
        src: Pic1,
        title: "Sala clínica 1",
        alt: "Sala clínica 1"
    },
    {
        src: Pic2,
        title: "Sala clínica 2",
        alt: "Sala clínica 3"
    },
    {
        src: Pic3,
        title: "Sala clínica 3",
        alt: "Sala clínica 3"
    }
]

const Gallery = () => (
    <div className="Clinica-Carousel-Container">
        <div className="Clinica-Carousel">

            <h3 className="Clinica-Carousel-Title">Nuestras instalaciones</h3>

            <Carousel showArrows={true} showIndicators={false} showThumbs={true} showStatus={false} autoPlay={true} infiniteLoop={true}>
                {/* Need to do it without component because Carousel does not support thumbnails in custom components */}
                { galleryPictures.map((e,i) => 
                    <div key={i}>
                        <img src={e.src} alt={e.alt} />
                        <h4 className="pic-legend">{e.title}</h4>
                    </div>
                )}
                
            </Carousel>
        </div>
    </div>
)

const ClinicaComponent = () => (
    <div className="Clinica">
        <TitleContentSection title="Nosotros"
        content="Aquí puede ver una pequeña lista de todo lo que tenemos a nuestro alcance para ofrecerle nuestros mejores tratamientos, así como una pequeña galería de imágenes de la clínica"
        />

        <div className="Clinica-Sections">
            <div className="Clinica-Section">
                <MessageBox title="EQUIPO">
                    { equipoContent.map((e,i) => <SectionPart key={i} content={e} /> )}
                </MessageBox>
            </div>

            <div className="Clinica-Section Clinica-Section-Instalaciones">
                <MessageBox title="INSTALACIONES">
                    { instalacionesContent.map((e,i) => <SectionPart key={i} content={e} /> )}
                </MessageBox>
            </div>
        </div>

        <Gallery />

    </div>
)

const Clinica = BaseComponent(ClinicaComponent, "Clinica")

export default Clinica


// WEBPACK FOOTER //
// ./src/components/clinica/Clinica.js